<div class="cx-one-sol-ui">
    <div #multidate *ngIf="maxDays !== 1">
        <!-- Dropdown with custom template options -->
        <sol-dropdown
            #drDropdown
            *ngIf="dateRangeOptions !== null"
            ariaLabel="Date range selector"
            [selection]="selectedDateRangeSol"
            [options]="dateRangeOptions"
            [isMultiple]="false"
            [disabled]="false"
            [placeholder]="'Select an option'"
            [optionsLabel]="'displayName'"
            [optionsValue]="'name'"
            [required]="false"
            [optionTemplate]="projectedContent"
            [selectedOptionTemplate]="selectedOptionTemplate">
        </sol-dropdown>

        <ng-template #projectedContent let-optionScope="optionScope">
            <div class="solDateOptionClick" (click)="onSolOptionClick(optionScope)">
                <span>{{ optionScope.displayText }}</span>
            </div>
        </ng-template>

        <ng-template #selectedOptionTemplate let-placeholderValue="placeholderValue">
            <span *ngIf="selectedDateRangeSol?.displayName === customRangeText">
                {{ formatDate(solDateRange.start) }} - {{ formatDate(solDateRange.end) }}
            </span>
            <span *ngIf="selectedDateRangeSol?.displayName !== customRangeText">
                {{ selectedDateRangeSol?.displayName }}
            </span>
        </ng-template>

        <!-- Date picker (calendar) -->
        <div #solDatePickerContainer>
            <div
                *ngIf="solDatePickerShowing" 
                class="position-absolute" style="z-index: 2">
                <sol-date-range-wrapper
                    [mode]="'inline'"
                    [type]="'range-selection'"
                    [min]="minDate"
                    [max]="maxDate"
                    [(ngModel)]="solDateRange"
                    (dateSelected)="onSolDateSelected($event)"
                    (closed)="onSolDatePickerClosed($event)"
                    (opened)="onSolDatePickerOpened()"
                ></sol-date-range-wrapper>
            </div>
        </div>
    </div>
    <div #singledate *ngIf="maxDays === 1" style="margin-top: 5px;">
        <sol-datepicker
            [ngModel]="singleDate"
            (ngModelChange)="onSingleDateChanged($event)"
            [showActionArrows]="false"
            [displayFooter]="false"
            [min]="minDate"
            [max]="maxDate"
            [format]="dateFormat"
            [noLabel]="true"
        ></sol-datepicker>
    </div>
</div>